import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import '@dcloudio/vue-cli-plugin-uni/packages/uni-cloud/dist/index.js';
import Vue from 'vue'
import Page from './uni_modules/uce-article/pages/detail.vue'
createPage(Page)